import { Auth } from '@/@types';
import { withPermission } from '@/components/Permissions';
import { DateHelper } from '@/helper';
import { eventAnalytics } from '@/providers';
import { TRACK_EVENTS } from '@/providers/eventAnalytics/trackEvents';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { HomeCard, HomeCardProps } from './homeCard';

export function ResultCard({
  type,
  result,
}: {
  type: 'imaging' | 'lab';
  result: { id: number | string; description: string; createdDateTime: string };
}) {
  const navigate = useNavigate();
  const date = DateHelper.formatDateToDisplay(DateTime.fromISO(result.createdDateTime));
  const buttons = useMemo((): HomeCardProps['buttons'] => {
    if (type === 'imaging') {
      return [
        {
          variant: 'primary',
          label: 'View details',
          onClick: () => {
            eventAnalytics.track(TRACK_EVENTS.HOME_PAGE_CARD_CLICKED, {
              cardName: 'Imaging records',
              buttonClicked: 'View details',
              resultId: result.id,
            });
            return navigate(`/results/imaging/${result.id}`);
          },
        },
        {
          label: 'View all',
          onClick: () => {
            eventAnalytics.track(TRACK_EVENTS.HOME_PAGE_CARD_CLICKED, {
              cardName: 'Imaging records',
              buttonClicked: 'View all',
            });
            return navigate('/results/imaging');
          },
        },
      ];
    }
    if (type === 'lab') {
      return [
        {
          variant: 'primary',
          label: 'View details',
          onClick: () => {
            eventAnalytics.track(TRACK_EVENTS.HOME_PAGE_CARD_CLICKED, {
              cardName: 'Lab records',
              buttonClicked: 'View details',
              resultId: result.id,
            });
            return navigate(`/results/lab/${result.id}`);
          },
        },
        {
          label: 'View all',
          onClick: () => {
            eventAnalytics.track(TRACK_EVENTS.HOME_PAGE_CARD_CLICKED, {
              cardName: 'Lab records',
              buttonClicked: 'View all',
            });
            return navigate('/results/lab');
          },
        },
      ];
    }
    return [];
  }, [navigate, result.id, type]);
  const category = useMemo(() => {
    if (type === 'imaging') {
      return 'Imaging results';
    }
    if (type === 'lab') {
      return 'Lab results';
    }
    return '';
  }, [type]);

  const Card = withPermission(HomeCard, Auth.Permissions.UserPermissions.VIEW_RESULTS);

  return (
    <Card category={category} title={result.description} descriptions={[date]} buttons={buttons} />
  );
}
